import styled from '@emotion/styled'

export const Body = styled.div`
    flex: 1;
    overflow: hidden auto;
    height: calc(100vh - 40px);
    font-family: ${props => props.theme?.fonts?.body};
    font-size: 1rem;

    .ory-cell-droppable {
        position: relative;

        &.ory-cell-droppable-is-over-left-of,
        &.ory-cell-droppable-is-over-right-of {
            overflow: hidden;
        }
    }

    .ory-cell-draggable {
        .component-border {
            border-width: 1px;
            border-style: dashed;
        }
    }

    .ory-cell-focused {
        box-shadow: 0 0 0 1px hotpink;
    }

    /* Fix for Chrome not deleting cells with iframes 
   when the iframe overlays the delete icon */
    .ory-cell-draggable-is-dragging {
        iframe {
            display: none;
        }

        .embed-iframe iframe {
            display: block;
        }
    }

    .component-wrapper {
        &:hover {
            > .component-border {
                border-width: 1px;
                border-style: dashed;
            }
        }
    }
`
